import script from "./TransactionFee.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionFee.vue?vue&type=script&setup=true&lang=js"

import "./TransactionFee.vue?vue&type=style&index=0&id=8a06e61a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a06e61a"]])

export default __exports__